import styled from 'styled-components';
import { designTokens } from '../../../../components/ui/foundation/DesignTokens';

// ===========================================
// COMPONENTES ESPECÍFICOS DE TAG FORM
// Solo componentes que NO están en el sistema de diseño
// ===========================================

/**
 * Container externo con padding y background
 */
export const TagFormWrapper = styled.div`
  width: 100%;
  min-height: 100%;
  padding: 24px 32px 32px;
  background: ${designTokens.colors.gray[50]};

  @media (max-width: 900px) {
    padding: 18px 16px 24px;
  }
`;

/**
 * Container principal del formulario de tag
 */
export const NewTagViewContainer = styled.div`
  padding: 24px;
  max-width: 600px;
`;

/**
 * Container del stepper de navegación
 */
export const StepperContainer = styled.div`
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${designTokens.colors.gray[100]};
`;

/**
 * Container del color picker con preview
 */
export const ColorBox = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
`;

/**
 * Título de la sección de color picker
 */
export const ColorTitle = styled.span`
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 1rem;
`;

/**
 * Container del color picker y preview
 */
export const ColorPick = styled.section`
  display: flex;
  width: 100%;
  gap: 24px;
  align-items: flex-start;

  /* Ocultar inputs innecesarios del color picker */
  & > div > :nth-child(3) {
    & :nth-child(8) {
      display: none !important;
    }
    & :nth-child(9) {
      display: none !important;
    }
  }

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

/**
 * Preview del color seleccionado
 */
export const ChooseColor = styled.div`
  background-color: ${(props) => props.color};
  width: 100px;
  height: 100px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  border: 2px solid #E5E7EB;
  flex-shrink: 0;

  @media (max-width: 900px) {
    width: 80px;
    height: 80px;
  }
`;
